<style lang="less" scoped>
    .comm_filtering {
      position: relative;
      padding: 5px 16px;
      background: #fff;
      margin-bottom: 20px;
      min-height: 50px;
      .more {
        text-align: content;
        float: right;
        cursor: pointer;

        > div {
          width: 89px;
          height: 31px;
          line-height: 31px;
          text-align: center;
          font-size: 12px;
          margin-top: 4px;
          box-sizing: border-box;
          padding: 0 8px;
          color: #666;
          border: 1px solid #e5e7ea;
          i {
            margin-left: 8px;
          }
        }
      }
      .searchLine {
        height: 40px;
        line-height: 40px;
        margin-bottom: 16px;
        border-bottom: 1px solid #e5e7ea;
        margin-left:-16px;
        margin-right:-16px;
        padding-left:16px;
        padding-right:16px;
      }
      .on {
        background: #20a0ff;
        color: #fff;
      }
      .comm_height {
        height: 39px;
        overflow: hidden;
      }
      .sea_height {
        overflow: hidden;
      }
      .sea_border {
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
      }
      .list_box {
        width: 50%;
        display: inline-block;
        padding-right: 40px;
        box-sizing: border-box;
      }
      .search_box {
        position: relative;
        height: 36px;
        border-bottom: 1px solid #e5e7ea;
      }
      .search_btn {
        position: absolute;
        width: 100%;
        padding-bottom: 5px;
        z-index: 80;
        box-sizing: border-box;
        margin-top: 1px;
        background: #fff;
        .search_height_mini,
        .search_height_max{
            >.btn_list {
                height: 25px;
                line-height: 25px;
                color: #666;
                float: left;
                cursor: pointer;
                padding: 0 16px;
                border: 1px solid rgba(255, 255, 255, 0);
                background: none;
                font-size: 12px;
                outline: none;
                margin-top: 5px;
            }
            >.btn_list:hover {
                color: #2babee;
                border: 1px solid #2babee;
            }
            .on {
                background: #20a0ff;
                color: #fff;
            }
            .on:hover {
                color: #fff;
            }
        }
        .search_height_max{
            padding-right: 40px;
            max-height: 200px;
            overflow-y: auto;
        }
        >.btn_list {
            height: 25px;
            line-height: 25px;
            color: #666;
            float: left;
            cursor: pointer;
            padding: 0 16px;
            border: 1px solid rgba(255, 255, 255, 0);
            background: none;
            font-size: 12px;
            outline: none;
            margin-top: 5px;
            }
        >.btn_list:hover {
            color: #2babee;
            border: 1px solid #2babee;
        }
        .on {
            background: #20a0ff;
            color: #fff;
        }
        .on:hover {
            color: #fff;
        }
        .search_more {
          color: #2babee;
          position: absolute;
          top: 0;
          right: 0;
          cursor: pointer;
          font-size: 12px;
          i {
            font-size: 10px;
          }
        }
      }
      .sea_zindex {
        z-index: 999;
        background: #fff;
      }
    }
</style>
<style>
    .comm_filtering .el-form-item {
        margin-bottom: 4px;
    }
    .searchLine .el-form-item .el-form-item__label {
        color: #666;
    }
    .searchLine .el-form-item__content .el-range-input {
        width: 100px;
    }
</style>
<template>
    <div class="comm_filtering">
        <div :class="{'comm_height': !more}">
          <div v-if="isShow" class="searchLine">
              <el-form ref="form" v-if="searchline" :model="form" label-width="80px">
              <el-form-item label="时间范围" v-if="searchShows" style="float:left;">
                  <el-date-picker @change="emitSearch" size="small" v-model="searchDate" type="daterange" style=" width:300px;" placeholder="选择日期范围！">
                  </el-date-picker>
              </el-form-item>
              <el-form-item label="搜索" v-if="inputShows" style="float:left;">
                  <el-input placeholder="请输入内容" size="small" v-model="searchInput" style=" width:180px;">
                  <el-button slot="append" icon="el-icon-search" @click='emitSearch'></el-button>
                  </el-input>
              </el-form-item>
              </el-form>
              <slot></slot>
              <div class="more">
              <div v-if="!more" @click="clickMore('open')">更多选项
                  <i class="fa fa-caret-down"></i>
              </div>
              <div v-if="more" @click="clickMore('close')">收起
                  <i class="fa fa-caret-up"></i>
              </div>
              </div>
          </div>
          <el-form ref="form" onsublime="return false;" label-width="90px">
              <div style="margin-top: -4px;">
                  <div class="list_box" v-for="(sItem,index) in searchItems" :key="index">
                      <el-form-item :label="sItem.title">
                          <div class="search_box" :class="{'sea_height': sItem.isMultiple}" @mouseleave="mouseout(sItem)">
                              <div class="search_btn" ref="element" :style=" sItem.isMultiple ? 'padding-right: 40px;':'padding-right: 4px;' " 
                                  :class="{'sea_border': !sItem.isMultiple,'sea_zindex':!sItem.isMultiple}">
                                  <!-- <div class="btn_list"  v-for="(s,sIndex) in sItem.options" :key="sIndex" :class="{'on':s.selected}" @click="clickBtn(index,sIndex),clickBtn2(index,sIndex)">{{s.label}}</div> -->
                                  <div class="search_height_mini" style="height: 35px;" v-if="sItem.isMultiple">
                                      <div class="btn_list" v-for="(s,sIndex) in sItem.options" :key="sIndex" :class="{'on':s.selected}" @click="clickBtn(index,sIndex),clickBtn2(index,sIndex)">{{s.label}}</div>
                                  </div>
                                  <div class="search_height_max" v-else>
                                      <div class="btn_list" v-for="(s,sIndex) in sItem.options" :key="sIndex" :class="{'on':s.selected}" @click="clickBtn(index,sIndex),clickBtn2(index,sIndex)">{{s.label}}</div>
                                  </div>
                                  <span class="search_more" @click="btnMore(sItem)" v-if="sItem.isOpen">
                                      更多
                                      <i class="el-icon-arrow-down"></i>
                                  </span>
                              </div>
                          </div>
                      </el-form-item>
                  </div>
              </div>
          </el-form>
        </div>
    </div>
</template>
<script>

export default {
  name: "comm_filtering",
  props: {
    searchItem: {
      type: Array,
      default() {
        return [];
      }
    },
    searchlines: {
      //日期关键字正行显示状态
      type: Boolean,
      default: true
    },
    inputShow: {
      //关键字显示状态
      type: Boolean,
      default: true
    },
    searchShow: {
      //日期显示状态
      type: Boolean,
      default: true
    },
    choosed: {
      type: Array,
      default() {
        return [];
      }
    },
    //配置时间筛选和关键字
    existTimeRange: {
      type: Boolean,
      default: true
    },
    //配置时间筛选和关键字
    existRange: {
      type: Boolean,
      default: true
    },
    //配置单选，多选
    existSelect: {
      type: Boolean,
      default: true
    },
    //配置单选，多选
    existClose: {
      type: Boolean,
      default: true
    },
    //配置是否展开筛选组件
    existOpen: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      more: false,
      istfs: true,
      isOpen: true,
      searchShows: true,
      inputShows: true,
      searchDate: "",
      searchInput: "",
      searchline: true,
      searchShows: true,
      inputShows: true,
      isShow: false,
      isShowRange: false,
      isClean: false,
      exist: true,
      searchItems: [],
      form: {}
    };
  },
  watch: {
    searchItem () {
      this.getWatch()
    }
  },
  mounted() {
    let vm = this;
    vm.exist = vm.existOpen;
    vm.searchItems = vm.searchItem;
    vm.isShow = vm.existTimeRange;
    vm.isShowRange = vm.existRange;
    vm.searchline = vm.searchlines;
    vm.searchShows = vm.searchShow;
    vm.inputShows = vm.inputShow;
  },
  methods: {
    clickMore(item) {
      let vm = this;
      if (item == "open") {
        vm.more = true;
        vm.moreBtn();
      }
      if (item == "close") {
        vm.more = false;
      }
    },
    getWatch(){
      let vm = this
      vm.searchItems = vm.searchItem;
      vm.moreBtn()
    },
    moreBtn() {
      let vm = this;
      let searchBtn = $(".search_btn");
      for (let i = 0; i < vm.searchItems.length; i++) {
        let seHeight = searchBtn[i].offsetHeight;
        console.log('seHeight',seHeight)
        if (seHeight > 41) {
          vm.searchItems[i].isOpen = true;
        } else {
          vm.searchItems[i].isOpen = false;
        }
      }
      vm.searchItems = vm.searchItems;
    },
    mouseout(item){
      let vm = this
      setTimeout(()=>{
        if(!item.isMultiple){
          item.isMultiple = true
          item.isOpen = true
        }
      },500)
    },
    options() {
      let vm = this;
      vm.$emit("setOptions");
    },
    emitSearch() {
      let searchDate = null;
      if (this.searchDate) {
        if (this.searchDate[0] !== null) {
          searchDate = {
            start: this.searchDate[0].getTime(),
            end: this.searchDate[1].getTime()
          };
        }
        if (this.searchDate[0] == null) {
          searchDate = {
            start: "",
            end: ""
          };
        }
      }
      this.$emit("emitSearch", {
        searchInput: this.searchInput,
        searchDate
      });
    },
    btnMore(item) {
      let vm = this;
      item.isOpen = false
      item.isMultiple = !item.isMultiple;
    },
    clickBtn(index, sIndex) {
      let vm = this;
      var s = vm.searchItems[index].options[sIndex];
      if (vm.searchItems[index].options[sIndex].id == "") {
        vm.searchItems[index].options[sIndex].selected = true;
        _.forEach(vm.searchItems[index].options, function(v) {
          if (v.id != "") {
            v.selected = false;
          }
        });
        vm.$emit("clcikbtn", vm.searchItems, vm.searchItems[index].title);
      }
      if (vm.searchItems[index].options[sIndex].id != ""){
        if (vm.exist == false) {
          //true为单选，false为多选
          //单选
          for (let i = 0; i < vm.searchItems[index].options.length; i++) {
            if (i == sIndex) {
              vm.searchItems[index].options[i].selected = true;
            } else if (i != sIndex) {
              vm.searchItems[index].options[i].selected = false;
            }
          }
          vm.$emit("clcikbtn", vm.searchItems, vm.searchItems[index].title);
        } else {
        //   //多选
          let arrs = [];
          vm.searchItems[index].options[0].selected = false
          vm.searchItems[index].options[sIndex].selected = !vm.searchItems[index].options[sIndex].selected
          _.each(vm.searchItems[index].options,vs=>{
            // console.log('vsvs',vs)
            if(vs.selected == true){
              arrs.push(vs)
            }
          })
          if (arrs.length == 0) {
            vm.searchItems[index].options[0].selected = true;
          }
        //   if (s.id != "") {
        //     s.selected = !s.selected;
        //     for (let i = 0; i < vm.searchItems[index].options.length; i++) {
        //       if (vm.searchItems[index].options[i].id == "") {
        //         vm.searchItems[index].options[i].selected = false;
        //       }
        //       if (vm.searchItems[index].options[i].selected) {
        //         arrs.push(vm.searchItems[index].options[i]);
        //       }
        //     }
        //   }
          vm.$emit("clcikbtn", vm.searchItems, vm.searchItems[index].title);
        }
      }
      switch (index) {
        case index:
         console.log("index",index)
          for (let i = 0; i < vm.searchItems.length; i++) {
            if (i > index) {
              _.forEach( vm.searchItems[i].options, (a,k) => {
                if (a.id == "") {
                  a.selected = true;
                } else if (a.id != "") {
                  a.selected = false;
                }
               
              });
            }
          } 
          break; 
      }
      // if(vm.searchItems){
      //   for (let i = 0; i < vm.searchItems.length; i++) {
      //     console.log('seHeight====>')
      //     let sewidth = searchBtn[i].offsetWidth;
      //       console.log('seHeight',i,'====>',vm.searchItems[i].options)
      //     for(let j = 0 ; j < vm.searchItems[i].options ; j++){
      //       console.log('seHeight','====>',j)
      //     }
      //     // if (seHeight > 41) {
      //     //   vm.searchItems[i].isOpen = true;
      //     // } else {
      //     //   vm.searchItems[i].isOpen = false;
      //     // }
      //   }
      // }
      setTimeout(()=>{
        vm.moreBtn()
      },1000)
      console.log('vm.searchItems===>',vm.searchItems)
    },
    shwoMoreBtn(index,sIndex){
      let vm = this
      _.each(vm.searchItems,si=>{
        let searchBtn = $(".search_btn");
        let btnList = $('.btn_list')
        console.log('类别行总宽度',searchBtn[index].offsetHeight,'每个按钮宽度',btnList[sIndex].clientWidth,'按钮属性',btnList)
      })
      // let searchBtn = $(".search_btn");
      // let btnList = $('.btn_list') 
      // let btnlistWdith = null
      //   btnlistWdith = btnList[k].offsetWidth
      //   btnlistWdith += btnlistWdith
        
      //   // console.log(vm.searchItems[i].title,'=>总宽',searchBtn[i].offsetWidth,'=>按钮个数',vm.searchItems[i].options.length,'=>按钮宽度',btnList[k].offsetWidth,'按钮宽度总和',btnlistWdith)
      //   if(btnlistWdith>(searchBtn[i].offsetWidth-40)){
      //     alert(vm.searchItems[i].title,'====>按钮长度超过显示框长度')
      //   }
      //   console.log(vm.searchItems[i].title,'=>总宽',btnlistWdith,btnList[k].offsetWidth) 
    },
    clickBtn2(index, sIndex) {
      let vm = this;
      let items = _.cloneDeep(vm.searchItems);
      var sItem = items[index];
      var s = sItem.options[sIndex];
    }
  }
};
</script>
    


// WEBPACK FOOTER //
// src/commonplugin/common/comm_filtering.vue